export const inputsState = {
  email: null,
  culture: null,
  name: null,
};
